"use client"

import { useEffect, useState } from "react";

export function ReadingProgressBar() {
  const [scroll, setScroll] = useState(0);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScroll(progress);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!mounted) return <div className="fixed top-0 left-0 w-full h-[3px] bg-transparent z-[100]" />;

  return (
    <div className="fixed top-0 left-0 w-full h-[3px] bg-transparent z-[100]">
      <div
        className="h-full bg-brand transition-all duration-150 ease-out shadow-[0_0_10px_rgba(230,0,0,0.5)]"
        style={{ width: `${scroll}%` }}
      />
    </div>
  );
}
